// extracted by mini-css-extract-plugin
export default {"tableBox":"tfPnJ9cQjLdX4E0jcJs8"};